import { copy } from './copy'

/**
 * Copy all content from generated content
 * @param {Object} content - Content object
 * @returns {Promise<boolean>} Success status
 */
export const copyAllContent = async (content) => {
  if (!content) return false

  const textParts = []

  // Add message
  if (content.message) {
    textParts.push(content.message)
  }

  // Add hashtags
  if (content.hashtags && content.hashtags.length > 0) {
    textParts.push(content.hashtags.join(' '))
  }

  // Add link
  if (content.link) {
    textParts.push(content.link)
  }

  const fullText = textParts.join('\n\n')
  return await copy(fullText, 'All content copied to clipboard')
}

/**
 * Copy just the text content
 * @param {Object} content - Content object
 * @returns {Promise<boolean>} Success status
 */
export const copyText = async (content) => {
  if (!content || !content.message) return false
  return await copy(content.message, 'Text copied to clipboard')
}

/**
 * Copy hashtags from content
 * @param {Object} content - Content object
 * @returns {Promise<boolean>} Success status
 */
export const copyHashtags = async (content) => {
  if (!content || !content.hashtags || content.hashtags.length === 0) return false
  return await copy(content.hashtags.join(' '), 'Hashtags copied to clipboard')
}

/**
 * Copy link from content
 * @param {Object} content - Content object
 * @returns {Promise<boolean>} Success status
 */
export const copyLink = async (content) => {
  if (!content || !content.link) return false
  return await copy(content.link, 'Link copied to clipboard')
}
